import React from 'react';
import ReactDOM from 'react-dom';
import Prototypes from 'prototypes';

import '@bswing/uhc-core/dist/fonts.css';
import '@bswing/uhc-core/dist/main.css';
import 'index.scss';

ReactDOM.render(<Prototypes />, document.getElementById('root'));
